// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

// ** Toast Imports
import { toast } from 'react-toastify';

export const getAttendancePolicy = createAsyncThunk('attendancePolicySliceData/getAttendancePolicy', async () => {
    try {
        let response = await axios.get('/AttendancePolicy', {
            headers: {
                'Content-Type': 'application/json'
            }
        });        
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});


export const getAttendancePolicyId = createAsyncThunk('attendancePolicySliceData/getAttendancePolicyId', async (id) => {
    try {
        let response = await axios.get('/AttendancePolicy/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteAttendancePolicy = createAsyncThunk('attendancePolicySliceData/deleteAttendancePolicy', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/AttendancePolicy/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Attendance Policy deleted successfully.');
        await dispatch(getAttendancePolicy());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createAttendancePolicy = createAsyncThunk('attendancePolicySliceData/createAttendancePolicy', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/AttendancePolicy', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Attendance Policy added succesfully.');
        await dispatch(getAttendancePolicy());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateAttendancePolicy = createAsyncThunk('attendancePolicySliceData/updateAttendancePolicy', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/AttendancePolicy/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Attendance Policy updated successfully.');
        await dispatch(getAttendancePolicy());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateAttendancePolicyStatus = createAsyncThunk('attendancePolicySliceData/updateAttendancePolicyStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put(
            '/AttendancePolicy/status/' + id,
            {},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        toast.success(response?.data?.message || 'Status Updated Successfully');
        await dispatch(getAttendancePolicy());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});


export const getAttendancePolicyOptions = createAsyncThunk('attendancePolicySliceData/getAttendancePolicyOptions', async () => {
    try {
        let response = await axios.get('/AttendancePolicy?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});


export const getEmployee = createAsyncThunk('attendancePolicySliceData/getEmployee', async () => {
    try {
        let response = await axios.get('/Employee', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const bulkAssignAttendancePolicy = createAsyncThunk(
    'attendancePolicySliceData/bulkAssignAttendancePolicy',
    async (data, { dispatch }) => {
        try {
             let response = await axios.post('/AttendancePolicy/assign-late-penalty-policy', data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            toast.success(response?.data?.message || 'Late penalty rule assigned successfully.');
            await dispatch(getAttendancePolicy());
            return Promise.resolve(response);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

export const getAssignedLatePenaltyEmployees = createAsyncThunk(
    'attendancePolicySliceData/getAssignedLatePenaltyEmployees',
    async (id) => {
        try {
            let response = await axios.get('/AttendancePolicy/assigned-employee/' + id, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return Promise.resolve(response?.data);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

export const attendancePolicySlice = createSlice({
    name: 'attendancePolicySliceData',
    initialState: {
        attendancePolicy: [],
        employeeList: [],
        attendancePolicyOptions: []
    },
    extraReducers: (builder) => {
        builder.addCase(getAttendancePolicy.fulfilled, (state, action) => {
            state.attendancePolicy = action?.payload;
            return;
        });
        builder.addCase(getEmployee.fulfilled, (state, action) => {
            state.employeeList = action?.payload;
            return;
        });
        builder.addCase(getAttendancePolicyOptions.fulfilled, (state, action) => {          
            state.attendancePolicyOptions = action?.payload;
            return;
        });
    }
});

export default attendancePolicySlice.reducer;
